import { VStack, Text, Box } from '@chakra-ui/react'
import React from 'react'

const EventDressDrive: React.FC = () => (
  <VStack spacing={4} align='stretch'>
    <Text fontSize='lg' fontWeight='bold'>
      Saturday, November 8, 2024
    </Text>
    <Text>12 PM - 2 PM</Text>
    <Text>
      <Box as='span' fontFamily='Cherry Swash' color='blue.500'>
        Shine Like Lauren, Inc.
      </Box>{' '}
      is hosting a Dress Drive for Cinderella's Closet!
    </Text>
    <Box>
      <Text fontWeight='bold' mb={2}>
        We are collecting:
      </Text>
      <Text>• Formal dresses in ALL sizes</Text>
      <Text>• Jewelry</Text>
      <Text>• Purses</Text>
      <Text>• Dress shoes</Text>
    </Box>
    <Text>
      Help us make prom and formal events accessible to all students by donating
      your gently used formal wear!
    </Text>
  </VStack>
)

export default EventDressDrive
